import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQAccordionProps {
  items: FAQItem[];
}

export default function FAQAccordion({ items }: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <div className="space-y-3">
      {items.map((item, idx) => (
        <div
          key={idx}
          className="border border-background-200/70 rounded-lg overflow-hidden transition-colors"
        >
          <button
            onClick={() => toggle(idx)}
            className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-100/70 transition-colors"
          >
            <span className="text-sm md:text-base font-medium text-foreground-900">
              {item.question}
            </span>
            <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 text-foreground-400 ${openIndex === idx ? 'rotate-180' : ''}`}>
              <i className="ri-arrow-down-s-line text-lg"></i>
            </span>
          </button>
          <div
            className={`transition-all duration-300 ease-in-out overflow-hidden ${
              openIndex === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
            }`}
          >
            <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
              {item.answer}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}